import { render, staticRenderFns } from "./Tools.vue?vue&type=template&id=5c4d7df6&scoped=true"
import script from "./Tools.vue?vue&type=script&lang=js"
export * from "./Tools.vue?vue&type=script&lang=js"
import style0 from "./Tools.vue?vue&type=style&index=0&id=5c4d7df6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4d7df6",
  null
  
)

export default component.exports